import { Link } from 'react-router-dom';
import { Linkedin, Mail, Phone } from 'lucide-react';

const Logo = ({ size = 'default' }) => {
  const isLarge = size === 'large';
  
  return (
    <img 
      src="https://customer-assets.emergentagent.com/job_better-site-13/artifacts/yrzg18jb_WhatsApp_Image_2026-02-10_at_18.35.57__1_-removebg-preview.png" 
      alt="ProAct AI" 
      className={`${isLarge ? 'h-20' : 'h-[68px]'} w-auto object-contain`}
    />
  );
};

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-gray-100 border-t border-gray-200">
      <div className="container-custom py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 items-start">
          <div className="md:col-span-1">
            <Logo />
            <p className="mt-3 text-muted-foreground text-xs leading-relaxed">
              Vision AI for retail intelligence.
            </p>
            <div className="mt-4 flex space-x-3">
              <a 
                href="https://www.linkedin.com/company/proactai/" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-linkedin"
                className="w-8 h-8 rounded-full bg-white border border-gray-200 flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
              >
                <Linkedin size={14} />
              </a>
              <a 
                href="mailto:sales@proactai.in"
                data-testid="social-email"
                className="w-8 h-8 rounded-full bg-white border border-gray-200 flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
              >
                <Mail size={14} />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-xs font-bold text-foreground uppercase tracking-wider mb-3 font-heading">Platform</h4>
            <ul className="space-y-2">
              <li><Link to="/solutions" className="text-muted-foreground hover:text-primary text-xs transition-colors">Solutions</Link></li>
              <li><Link to="/how-it-works" className="text-muted-foreground hover:text-primary text-xs transition-colors">How It Works</Link></li>
              <li><Link to="/case-studies" className="text-muted-foreground hover:text-primary text-xs transition-colors">Client Outcomes</Link></li>
              <li><Link to="/partners" className="text-muted-foreground hover:text-primary text-xs transition-colors">Partners</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold text-foreground uppercase tracking-wider mb-3 font-heading">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-muted-foreground hover:text-primary text-xs transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-primary text-xs transition-colors">Contact</Link></li>
              <li><Link to="/privacy-policy" className="text-muted-foreground hover:text-primary text-xs transition-colors">Privacy Policy</Link></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary text-xs transition-colors">Terms</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold text-foreground uppercase tracking-wider mb-3 font-heading">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="mailto:sales@proactai.in" className="inline-flex items-center gap-2 text-foreground hover:text-primary text-xs font-bold transition-colors">
                  <Mail size={14} className="text-primary" />
                  sales@proactai.in
                </a>
              </li>
              <li>
                <a href="tel:+919871621133" className="inline-flex items-center gap-2 text-foreground hover:text-primary text-xs font-bold transition-colors">
                  <Phone size={14} className="text-primary" />
                  +91 9871621133
                </a>
              </li>
              <li>
                <a 
                  href="https://www.linkedin.com/company/proactai/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-foreground hover:text-primary text-xs font-bold transition-colors"
                >
                  <Linkedin size={14} className="text-primary" />
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-6 pt-4 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
          <p className="text-muted-foreground text-xs">© 2024 ProAct AI. All rights reserved.</p>
          <Link to="/contact" className="text-xs font-semibold text-primary hover:underline mt-2 md:mt-0">Request Demo →</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
